module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/group-30@3x.d2d5feff.png";